import type { ComponentType } from 'react';
import React from 'react';
import {
  Alipay,
  Amex,
  DinersClub,
  Discover,
  Elo,
  Generic,
  Jcb,
  Maestro,
  Mastercard,
  UnionPay,
  Visa,
  Wechatpay,
} from 'react-pay-icons';
import type { StripePaymentMethod } from 'types/stripePayment';

/**
 * Maps Stripe's `card.brand` values to a react-pay-icons component.
 * Only covers brands Stripe actually returns; everything else falls back
 * to the Generic card icon so the UI never breaks on new brands.
 *
 * Stripe brand reference:
 * https://stripe.com/docs/api/payment_methods/object#payment_method_object-card-brand
 */
const BRAND_ICON_MAP: Record<string, ComponentType<any>> = {
  visa: Visa,
  mastercard: Mastercard,
  amex: Amex,
  american_express: Amex,
  discover: Discover,
  diners: DinersClub,
  diners_club: DinersClub,
  jcb: Jcb,
  unionpay: UnionPay,
  maestro: Maestro,
  elo: Elo,
  alipay: Alipay,
  wechat: Wechatpay,
  wechat_pay: Wechatpay,
};

export const getBrandIconComponent = (
  brand: string | null | undefined,
): ComponentType<any> => {
  if (!brand) return Generic;
  return BRAND_ICON_MAP[brand.toLowerCase()] ?? Generic;
};

export const parseStripePaymentMethod = (
  raw: unknown,
): StripePaymentMethod | null => {
  if (!raw) return null;
  const pm = raw as Record<string, unknown>;
  if (typeof pm.type !== 'string') return null;
  return pm as unknown as StripePaymentMethod;
};
